__turbopack_context__.v({
  "Arrow": "_0gYeza_Arrow",
  "Description": "_0gYeza_Description",
  "DetailItem": "_0gYeza_DetailItem",
  "Details": "_0gYeza_Details",
  "FlowmapPopup": "_0gYeza_FlowmapPopup",
  "FlowmapPopupWrapper": "_0gYeza_FlowmapPopupWrapper",
  "Header": "_0gYeza_Header",
  "Label": "_0gYeza_Label",
  "Route": "_0gYeza_Route",
  "Value": "_0gYeza_Value",
  "skeleton-loading": "_0gYeza_skeleton-loading",
});
